import { PriorityTypes } from "types";

const loadOptions = () => {
	try {
		const options = PriorityTypes.getOptions();

		return {
			options,
			hasMore: false,
		};
	} catch {
		return { options: [] };
	}
};

const supportLevelColumn = () => ({
	name: "priorityType",
	type: "select" as const,
	loadOptions,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option.value,
	placeholder: "Support Level",
});

export default supportLevelColumn;
